import {SupportFrame} from "./SupportFrame";
import {ErrorStateDomain} from "../general/ErrorViewer";
import {CookieConsent} from "react-cookie-consent";
import {useTranslation} from "react-i18next";
import React from "react";
import {CookiesProvider} from "react-cookie";
import {AuthProvider} from "../auth/AuthHook";
import {BrowserRouter, Route, RouterProvider, Routes} from "react-router-dom";
import {CaseStateMapContext, CaseStateMapProvider, SendingLimitsProvider, SupportCaseState} from "./CaseHook";

interface SupportAppProps {
    basePath: string,
    allowCookieConsent: boolean
    showEmbedded: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SupportApp(props: SupportAppProps) {
    const {t} = useTranslation()

    console.log(`Cookie consent allowed: ${props.allowCookieConsent}`)
    return (
        <div className="dark:bg-slate-800 dark:text-gray-300 h-screen">
            <ErrorStateDomain>
                        <AuthProvider setupEndpoint={"auth_setup"}>
                            <SendingLimitsProvider>
                                <CaseStateMapProvider>
                                    <div className="flex flex-col h-screen">
                                        <SupportFrame showEmbedded={props.showEmbedded}/>
                                        {props.allowCookieConsent && <CookieConsent
                                            location="bottom"
                                            buttonText={t("Accept cookies")}
                                            declineButtonText={t("Decline cookies")}
                                            enableDeclineButton={true}
                                            flipButtons={true}
                                            style={{background: "#2B373B"}}
                                            buttonStyle={{color: "#4e503b", fontSize: "13px"}}
                                            debug={false}
                                        >
                                            {t("Cookie consent")}
                                        </CookieConsent>}
                                    </div>
                                </CaseStateMapProvider>
                            </SendingLimitsProvider>
                        </AuthProvider>
            </ErrorStateDomain>
        </div>
    )
}